import { tButton, tWhatsappApiHook } from './WhatsappApi.types.ts';
import { eTemplateCategory, eWhatsappApiWindow } from './WhatsappApi.enum.ts';
import { tVariable } from './components/CreateTemplate/components/DataTemplate/DataTemplate.types.ts';
import { tCreateTemplateForm } from 'src/pages/WhatsappApi/components/CreateTemplate/CreateOrEditTemplate.types.ts';

export const WHATSAPP_API_INITIAL_STATE: tWhatsappApiHook = {
  templateDrafts: [],
  templateDraftsLoaded: false,
  refreshTemplateDrafts: async () => {},
  draftToEdit: null,
  setDraftToEdit: () => {},
  templates: [],
  setTemplates: () => {},
  templatesHydrated: false,
  templatesFetchFailed: false,
  templateLink: null,
  openTemplateLink: () => {},
  clearTemplateLink: () => {},
  filteredTemplates: [],
  setFilteredTemplates: () => {},
  loading: false,
  setLoading: () => {},
  searchTemplates: async () => {},
  whatsappApiWindow: eWhatsappApiWindow.GENERAL,
  setWhatsappApiWindow: () => {},
  createTemplateFormik: undefined,
  mediaPreview: null,
  setMediaPreview: () => {},
  mediaType: null,
  setMediaType: () => {},
  showInput: null,
  setShowInput: () => {},
  step: 1,
  setStep: () => {},
  editMode: false,
  setEditMode: () => {},
  templateToEdit: null,
  setTemplateToEdit: () => {},
  pendingFlowForTemplate: null,
  setPendingFlowForTemplate: () => {},
  pendingTemplateCategory: null,
  setPendingTemplateCategory: () => {},
  injectDataToFormik: () => {},
  sortBy: () => {},
  syncTemplates: async () => {},
  getAndParseTemplates: async () => {},
  usageRecord: null,
  setUsageRecord: () => {},
  statisticsRecord: null,
  setStatisticsRecord: () => {},
  getStatistics: async () => {},
  selectedPeriod: 'last_7_days',
  setSelectedPeriod: () => {},
  handlePeriodChange: () => {},
  accountData: null,
  setAccountData: () => {},
  validateTemplateEditEligibility: () => ({ canEdit: false }),
  setTemplateStatus: () => {},
  templateStatus: undefined,
  templateCounter: undefined,
  setTemplateCounter: () => {},
  undeliveredMessage: undefined,
  accountHealthStatus: 'OK',
  violationType: null,
  purchaseOneTimeCredits: async () => {},
  refreshCredits: async () => {},
  fetchOneTimeCreditData: async () => {},
  oneTimeCreditProducts: [],
  oneTimeCreditPaymentMethods: [],
  fetchingOneTimeCreditData: false,
  // General Tab - redesign fields
  accountInfo: null,
  creditsInfo: null,
  messageStatistics: null,
  statisticsLoading: false,
  notifications: [],
  notificationsLoading: false,
  notificationsHasMore: false,
  unreadCount: 0,
  loadMoreNotifications: async () => {},
  markNotificationRead: async () => {},
  markAllNotificationsRead: async () => {},
  notificationFilter: 'pending',
  setNotificationFilter: () => {},
  notificationCategory: null,
  setNotificationCategory: () => {},
  statisticsDateRange: { start: '', end: '' },
  handleStatisticsDateChange: () => {},
  showInvalidDateModal: false,
  setShowInvalidDateModal: () => {},
  invalidDateReason: 'future',
  showQualityModal: false,
  setShowQualityModal: () => {},
  // GRO-811: One-Time Credits — Figma alignment (additive only)
  creditPackages: null,
  setCreditPackages: () => {},
  creditUnitPriceCents: null,
  setCreditUnitPriceCents: () => {},
  creditCurrency: null,
  setCreditCurrency: () => {},
  paymentMethods: null,
  setPaymentMethods: () => {},
  creditsBalance: null,
  setCreditsBalance: () => {},
  purchaseHistory: null,
  setPurchaseHistory: () => {},
  purchaseDraft: {},
  setPurchaseDraft: () => {},
  currentStep: 'idle',
  setCurrentStep: () => {},
};

export const initialCreateTemplateFormikValues: tCreateTemplateForm = {
  name: '',
  header: '',
  templateType: eTemplateCategory.MARKETING,
  text: '👋 Hola leadsaler',
  footer: '',
  headerVariable: '',
  headerExample: '',
  variables: [] as tVariable[],
  buttons: [] as tButton[],
};
